import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import classNames from 'classnames';
import NavLink from './common/NavLink';
import * as urls from '../actions/urlTypes';
import * as messages from '../messages/NavigationMessages';
import {
  STORIES_FEATUREID,
  VISA_HAUL_LABEL,
  MME_FEATUREID,
  DATAHAUL_FEATUREID,
  CORRCLUSTER_FEATUREID,
} from '../constants';
// import { MME_LABEL, GEOMAPPING_FEATUREID } from '../constants';
import { enableInDevOnly, isFeaturePresent } from '../util/CommonUtils';
import {
  NAV_CT1,
  NAV_CO1,
  NAV_CT2,
  NAVIGATION_MODULE,
} from '../trackerConstants';
import { saveTrackingData } from '../util/trackerUtils';
import { useSelector } from './common/react-redux-hooks';

const EssentialsNav = ({ loginResponse, modulePermissions, children }) => {
  let visaHaulEnabled = false;
  let dataHaulEnabled = true;
  let mmeEnabled = false;
  let corrClustEnabled = false;
  const { uid, currentAccountId } = loginResponse.data;
  const { activeStudy } = useSelector(state => ({
    activeStudy: state.study.crosstabStudy,
  }));
  if (modulePermissions.length > 0) {
    visaHaulEnabled = isFeaturePresent(STORIES_FEATUREID, modulePermissions);
    mmeEnabled = isFeaturePresent(MME_FEATUREID, modulePermissions);
    corrClustEnabled = isFeaturePresent(
      CORRCLUSTER_FEATUREID,
      modulePermissions
    );
    if (loginResponse.data.universityUser) {
      dataHaulEnabled = isFeaturePresent(DATAHAUL_FEATUREID, modulePermissions);
    }
  }
  const triggerSaveTrackCall = value => {
    let action = NAV_CT1;
    let triggerTrackCall = false;
    if (value === messages.COMPOSER) {
      action = NAV_CO1;
    } else if (value === messages.CROSSTAB_V2) {
      action = NAV_CT2;
      triggerTrackCall = true;
    }
    if (activeStudy && activeStudy.pn) {
      saveTrackingData({
        uid,
        accid: currentAccountId,
        productNo: activeStudy.pn,
        moduleName: NAVIGATION_MODULE,
        action,
        triggerTrackCall,
      });
    }
  };
  return (
    <nav className="nav-dropdown-menu--items">
      <ul className="nav-dropdown-menu--list">
        <li>
          <NavLink
            to={`${urls.APP_ROOT_URL}/essentials/crosstab`}
            onClick={() => triggerSaveTrackCall(messages.CROSSTAB)}
          >
            {messages.CROSSTAB}
          </NavLink>
        </li>

        <li>
          <NavLink
            to={`${urls.APP_ROOT_URL}/essentials/crosstab?composer=1`}
            onClick={() => triggerSaveTrackCall(messages.COMPOSER)}
          >
            {messages.COMPOSER}
          </NavLink>
        </li>
        <li>
          <NavLink to={`${urls.APP_ROOT_URL}/essentials/quickreports`}>
            {messages.QUICK_REPORTS}
          </NavLink>
        </li>
        {dataHaulEnabled && (
          <li>
            <NavLink to={`${urls.APP_ROOT_URL}/essentials/datahaul`}>
              {messages.DATAHAUL}
            </NavLink>
          </li>
        )}
        <li>
          <NavLink to={`${urls.APP_ROOT_URL}/essentials/geomap`}>
            {messages.GEO_MAPPING}
          </NavLink>
        </li>
        {enableInDevOnly() && (
          <li>
            <NavLink
              to={`${urls.APP_ROOT_URL}/essentials/crosstabPOC/dropdown`}
            >
              Crosstab POC
            </NavLink>
          </li>
        )}
        {mmeEnabled && (
          <li>
            <NavLink to={`${urls.APP_ROOT_URL}/essentials/mme`}>MME</NavLink>
          </li>
        )}
        {corrClustEnabled && (
          <li>
            <NavLink
              to={`${urls.APP_ROOT_URL}/essentials/correspondencecluster`}
            >
              <div style={{ wordWrap: 'break-word' }}>
                Correspondence and Cluster
              </div>
            </NavLink>
          </li>
        )}
        {visaHaulEnabled && (
          <li>
            <NavLink to={`${urls.APP_ROOT_URL}/essentials/stories`}>
              {VISA_HAUL_LABEL}
            </NavLink>
          </li>
        )}
      </ul>
      {children}
    </nav>
  );
};

EssentialsNav.propTypes = {
  children: PropTypes.node,
  modulePermissions: PropTypes.instanceOf(Array),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      universityUser: PropTypes.bool,
      uid: PropTypes.number,
      currentAccountId: PropTypes.number,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    modulePermissions: state.userDetail.permissions,
  };
}

export default connect(mapStateToProps, null)(EssentialsNav);
